import ActiveUsersChart from '@/components/Analytics/ActiveUsersChart';
import GasConsumptionChart from '@/components/Analytics/GasConsumptionChart';
import RevenueChart from '@/components/Analytics/RevenueChart';
import TotalValueLockedChart from '@/components/Analytics/TotalValueLockedChart';
import TradingVolumeChart from '@/components/Analytics/TradingVolumeChart';
import TransactionsChart from '@/components/Analytics/TransactionsChart';
import { useAnalytics } from '@/contexts/AnalyticsContext';
import React from 'react';

const SpotSection: React.FC = () => {
  const { data, loading } = useAnalytics();

  return (
    <section>
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-text-black">Spot</h2>
      </div>

      {loading && (
        <div className="flex items-center justify-center h-64">
          <div className="text-text-main-body">Loading chart data...</div>
        </div>
      )}

      {!loading && data && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <TradingVolumeChart data={data.spot.volume?.data || undefined} />
          <ActiveUsersChart data={data.spot.users?.data || undefined} />
          <TotalValueLockedChart data={data.spot.tvl?.data || undefined} />
          <TransactionsChart data={data.spot.transactions?.data || undefined} />
          <RevenueChart data={data.spot.revenue?.data || undefined} />
          <GasConsumptionChart data={data.spot.gasConsumption?.data || undefined} />
        </div>
      )}
    </section>
  );
};

export default SpotSection;
